import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
import banner1 from '../assets/banners/foreign-tiktok-account-cr-selar.com-68ea7658021a6.jpg';
import banner2 from '../assets/banners/step-by-step-guide-to-cre-selar.com-69b4b5e86ce0b.jpg';

const WelcomeModal = () => {
  const [show, setShow] = useState(false);
  const [current, setCurrent] = useState(0);

  const close = () => {
    setShow(false);
    localStorage.setItem('welcome_modal_shown', Date.now().toString());
  };

  useEffect(() => {
    localStorage.removeItem('welcome_modal_shown');

    const t1 = setTimeout(() => {
      setCurrent(1);
      setShow(true);
    }, 1500);

    const t2 = setTimeout(() => setShow(false), 4000);

    const t3 = setTimeout(() => {
      setCurrent(2);
      setShow(true);
    }, 4500);

    const t4 = setTimeout(() => setShow(false), 7000);

    const t5 = setTimeout(() => {
      localStorage.setItem('welcome_modal_shown', Date.now().toString());
    }, 7500);

    return () => { clearTimeout(t1); clearTimeout(t2); clearTimeout(t3); clearTimeout(t4); clearTimeout(t5); };
  }, []);

  if (!show || current === 0) return null;

  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm">
      <motion.div
        key={current}
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        exit={{ scale: 0.8, opacity: 0 }}
        transition={{ type: 'spring', damping: 20, stiffness: 300 }}
        className="relative max-w-lg w-full rounded-2xl overflow-hidden shadow-2xl"
      >
        <button
          onClick={close}
          className="absolute top-3 right-3 z-10 w-9 h-9 rounded-full bg-black/60 hover:bg-black/80 text-white flex items-center justify-center transition-all"
        >
          <X size={18} />
        </button>
        <img
          src={current === 1 ? banner1 : banner2}
          alt="Welcome"
          className="w-full h-auto object-cover"
        />
      </motion.div>
    </div>
  );
};

export default WelcomeModal;